"use strict";

function showTab(index) {
  const tabs = document.querySelectorAll('.oisix__tab');
  const buttons = document.querySelectorAll('.oisix__menu__button');
  const wrapper = document.querySelector('.oisix__menu-wrapper');
  const viewportWidth = window.innerWidth;

  // 初期化
  tabs.forEach(tab => tab.classList.remove('active'));
  buttons.forEach(button => button.classList.remove('active'));

  // 対応するタブとボタンをアクティブに
  tabs[index]?.classList.add('active');
  buttons[index]?.classList.add('active');

  wrapper.style.background = index === 0 && viewportWidth <= 767 ? 'none' : '#F9F7F5';
}

